import { render } from "./AccountInquiries.vue?vue&type=template&id=74a38b91"
import script from "./AccountInquiries.vue?vue&type=script&lang=js"
export * from "./AccountInquiries.vue?vue&type=script&lang=js"

import "./AccountInquiries.vue?vue&type=style&index=0&id=74a38b91&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__